import React, {useEffect, useState} from 'react';
import 'assets/scss/page/first-screen-page-style.scss';
import logoFooter from 'assets/images/turkish-airlines-logo/logo-turkishairlines.svg';
import logoLoading from 'assets/images/loading_alternative.gif';
import {initInflight} from "../../api/inflight/InflightService";
import {UAParser} from "ua-parser-js";
import {useSetRecoilState} from "recoil";
import {agentAtom} from "../../store/AgentStore";
import Const from "../../constant/Const";
import {connectionErrorAtom} from "../../store/ConnectionErrorStore";
import {setSimulationNumber} from '../../util/SimulationManager';

const FirstScreenPage = (props) => {
    const initListener = props.initListener;
    const {flight, setFlight, handleInformation} = props.props;
    const simulationNumber = setSimulationNumber();
    const setAgent = useSetRecoilState(agentAtom);
    const [failed, setFailed] = useState(false);
    const setConnectionError = useSetRecoilState(connectionErrorAtom);
    let firstFailed = false;
    let reConnect = null;

    let dataFlight = {};

    useEffect(() => {
        starting();
        handleInformation("first_screen");
        simulationNumber(1, 1);
    }, []);

    const starting = () => {
        clearCache();
        setAgent(new UAParser().getResult());
        connectTo();
        initListener();

        // setTimeout(() => {
        //     setConnectionError(true)
        // }, 3000);

        // axios.post("https://onboard.tkwifi.net/api/v1/airtime/user_session", {email: "", password: ""}).then(e => {
        //     axios.get("https://onboard.tkwifi.net/api/v1/airtime/flight", {
        //         headers: {
        //             "auth-token": e.data?.auth_token
        //         }
        //     }).then(e => {
        //         console.log(e.data);
        //     });
        // });
    }

    const clearCache = () => {
        localStorage.removeItem(Const.RECOIL_PERSIST);
        localStorage.removeItem(Const.JWT);
        localStorage.removeItem(Const.FLIGHT_ID);
        localStorage.removeItem(Const.PANASONIC_LOG);
        localStorage.removeItem(Const.FEEDBACK_COUNT);
    }

    const connectTo = () => {
        initInflight((status, macId, clientIp, tailNumber, origin, destination, clientId) => {
            if (status) {
                tailNumber = tailNumber.replace("-", "");
                dataFlight = {
                    macId: macId,
                    clientIp: clientIp,
                    tailNumber: tailNumber,
                    origin: origin,
                    destination: destination,
                    clientId: clientId
                };
                dataFlight.domestic = false;
                dataFlight.range = "LONG";
                setupFlightState();

                if (clientIp === undefined || clientIp === null) {
                    errorRedirect(false);
                    return;
                }

            } else {
                errorRedirect();
            }
        });
    }

    const errorRedirect = () => {
        setConnectionError(true);
        firstFailed = true;
        setFailed(true);

        if (reConnect != null) clearTimeout(reConnect);
        reConnect = setTimeout(() => {
            if (firstFailed)
                starting();
        }, 10000);
    }

    const setupFlightState = () => {
        setFlight({
            ...flight,
            macId: dataFlight.macId,
            clientIp: dataFlight.clientIp,
            tailNumber: dataFlight.tailNumber,
            origin: dataFlight.origin,
            destination: dataFlight.destination,
            clientId: dataFlight.clientId,
            domestic: dataFlight.domestic,
            range: dataFlight.range
        });
    }

    return (
        <div className="splash-screen-root-div">
            <div className="splash-screen-root-inner">
                <img className="splash-screen-root-img" alt="Logo" src={logoLoading}></img>
            </div>
            <img className="footer-logo-tt" alt="Logo" src={logoFooter}></img>
        </div>
    );
};

export default FirstScreenPage;

